import React, { useEffect, useState } from 'react'
import { axiosGet } from '../util/api'
import { Table } from '../components/ui/Table'
import { useTableHooks } from '../packages/blueprint-components/src/useTableHooks'
import { format } from 'date-fns'
import { useSelector } from 'react-redux'
import { updateStatusString } from '../constants/update_status'
import { adTypeStringFull } from '../config'
import { UpdateStatuses } from './admin/updates/admin_updates_state'
import { Chart } from '../components/chart/chart'
import { State } from '../reducers'
import type { EntityId } from '../types/constants'

export const UserDataSyncs = ({ leadingActions = null }: { leadingActions?: React.ReactNode }) => {
    const [loading, setLoading] = useState<boolean>(false)
    const [graphData, setGraphData] = useState<number[][]>([[], [], [], []])
    const [total, setTotal] = useState<number>(0)

    useEffect(() => {
        setLoading(true)
        axiosGet('updates/counts')
            .then((resp) => {
                const res: { [key: number]: UpdateStatuses<number> } = resp.data

                const ts = Object.keys(res).map((x) => parseInt(x))
                const vals = Object.values(res).map((x: UpdateStatuses<number>) => x.success)
                const total = vals.reduce((a, b) => a + b, 0)

                setGraphData([ts, vals, [], []])
                setTotal(total)
                setLoading(false)
            })
            .catch(() => {
                setLoading(false)
            })
    }, [])

    const profile = useSelector<State, EntityId | null>((state) => state.user.profile)
    const load = (params: any) => {
        if (!profile) {
            return Promise.resolve()
        }

        return axiosGet('updates', params)
    }

    const tableHooks = useTableHooks(load)

    const tableOptions = {
        name: 'Data Syncs',
        showHeader: false,
        cardClassName: 'table-header-top-border',
        tableHooks,
        filters: null,
        leadingActions,
        toolbarClassName: 'border-t border-[#E5E7EB]',
        dateSelect: true,
        columns: columns,
        onSelectChange: null,
        selectKey: 'id',
    }

    return (
        <Table {...tableOptions} columnSelection={false}>
            <div className="border-r border-[#E5E7EB]">
                <Chart
                    loading={loading}
                    compare={false}
                    title="Successful Data Syncs"
                    data={graphData}
                    current={total}
                    previous={0}
                />
            </div>
        </Table>
    )
}

const columns = [
    {
        key: 'created_at',
        title: 'Date',
        sortable: true,
        formatter: (v: string) => format(new Date(v), 'M/d/yy hh:mm a'),
    },
    {
        key: 'status_id',
        title: 'Status',
        sortable: true,
        formatter: (statusId: number) => updateStatusString(statusId),
    },
    {
        key: 'platform_type_id',
        title: 'Advertising Platform',
        sortable: true,
        formatter: (platformId: number) => adTypeStringFull(platformId),
    },
]
